module.exports = __webpack_public_path__ + "static/img/brand-15.b7f4c7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-15.png
// module id = 2QeK
// module chunks = 1